import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="country-select"
export default class extends Controller {
  static targets = ["countryInput", "optionTemplate", "countryCode"];

  static values = {
    noResultsMessage: String,
  };

  connect() {
    this.tomSelect = new TomSelect(this.countryInputTarget, {
      valueField: "value",
      searchField: ["text", "code", "iso3Code"],
      plugins: ["dropdown_input"],
      maxOptions: null,
      onChange: (data) => {
        if (this.hasCountryCodeTarget) {
          this.countryCodeTarget.textContent = this.tomSelect.options[data]?.code;
        }
      },
      render: {
        option: (data) => {
          const { text } = data;
          return this.createOptionElement(text);
        },
        no_results: () => {
          return `<div class="no-results">${this.noResultsMessageValue}</div>`;
        },
        item: (data) => {
          const { text } = data;
          return this.createOptionElement(text);
        },
      },
    });
  }

  createOptionElement(text) {
    const optionTemplate = this.optionTemplateTarget.content.cloneNode(true);
    const optionElement = optionTemplate.querySelector(".country--option");
    const textElement = optionTemplate.querySelector(".country--text");

    textElement.textContent = text;

    return optionElement;
  }

  updatedCountry(event) {
    const newValue = event.target.value;
    this.tomSelect.setValue(newValue, true); // Silent to avoid triggering change event
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }
  }
}
